import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { MyContext } from '../../context/MyContext';

export const Logout = () => {
    const context = useContext(MyContext);
    context.logoutUser();
    return <Redirect to="/login" />;
};
